<template>
    <div class="ds-staff-table-row">
        <div class="ds-staff-table-position">
            {{ position }}
        </div>
        <div>
            {{ schedule }}
        </div>
        <div>
            {{ item.count }}
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { Staff } from '@/types';
interface Props {
    item: Staff
}

import { useScheduleStore } from '@/stores/scheduleStore';
const store = useScheduleStore()

const { item } = defineProps<Props>()

const position = computed(() => store.positions.find(pos => pos.id === item.position_id)?.name)
const schedule = computed(() => store.shiftSchedules.find(schedule => schedule.id === item.shift_schedule_id)?.name)

</script>
